import React from "react"
import { Router, Route } from "react-router"

import "./components/global.js"

// PUBLIC 
import Loading from "./page/Loading";
import Login from "./page/Login";
import NotFound from "./page/NotFound";

//ADMIN
import Dashboard from "./page/admin/Dashboard";
import Console from "./page/admin/Console";
import Log from "./page/admin/Log";
import Master from "./page/admin/Master";

// MANAGE REPAIR 
import CalendarRepair from "./page/admin/ManageRepair/CalendarRepair";
import CreateUpdateRepair from "./page/admin/ManageRepair/CreateUpdateRepair";
import ListRepair from "./page/admin/ManageRepair/ListRepair";

// MASTER
import CreateUpdateCustomer from "./page/admin/Master/CreateUpdateCustomer";
import CreateUpdateRole from "./page/admin/Master/CreateUpdateRole";
import CreateUpdateSparePartsRepair from "./page/admin/Master/CreateUpdateSparePartsRepair";
import ListAdmin from "./page/admin/Master/ListAdmin";
import ListCar from "./page/admin/Master/ListCar";
import ListCategory from "./page/admin/Master/ListCategory";
import ListWarehouse from "./page/admin/Master/ListWarehouse";
import ListCustomer from "./page/admin/Master/ListCustomer";
import ListInsurance from "./page/admin/Master/ListInsurance";
import ListRole from "./page/admin/Master/ListRole";
import ListSparePartsRepair from "./page/admin/Master/ListSparePartsRepair";
import ListSuppliers from "./page/admin/Master/ListSuppliers";
import BarcodeConfig from "./page/admin/Master/BarcodeConfig";
import ListBarcodeForSpare from "./page/admin/Master/ListBarcodeForSpare";

// ORDER
import ApproveOrderDetail from "./page/admin/Order/ApproveOrderDetail";
import CreateUpdateOrder from "./page/admin/Order/CreateUpdateOrder";
import CreateUpdateReceipt from "./page/admin/Order/CreateUpdateReceipt";
import ListApproveOrder from "./page/admin/Order/ListApproveOrder";
import ListOrder from "./page/admin/Order/ListOrder";
import ListReceipt from "./page/admin/Order/ListReceipt";

// REPORT 
import ReportBilling from "./page/admin/Report/ReportBilling";
import ReportReceipt from "./page/admin/Report/ReportReceipt";
import ReportRepair from "./page/admin/Report/ReportRepair";
import ReportSpareParts from "./page/admin/Report/ReportSpareParts";
import ReportSparePartsMinimal from "./page/admin/Report/ReportSparePartsMinimal";
import ReportStock from "./page/admin/Report/ReportStock";
import ReportRecievedSpareParts from "./page/admin/Report/ReportRecievedSpareParts";
import ReportInsuurePart from "./page/admin/Report/ReportInsuurePart";

// SALE
import CreateUpdateBilling from "./page/admin/Sale/CreateUpdateBilling";
import CreateUpdateInvoice from "./page/admin/Sale/CreateUpdateInvoice";
import CreateUpdateQuotation from "./page/admin/Sale/CreateUpdateQuotation";
import CreateUpdateSale from "./page/admin/Sale/CreateUpdateSale";
import ListBilling from "./page/admin/Sale/ListBilling";
import ListInvoice from "./page/admin/Sale/ListInvoice";
import ListQuotation from "./page/admin/Sale/ListQuotation";
import ListSale from "./page/admin/Sale/ListSale";

// STOCK
import CreateUpdateSpareParts from "./page/admin/Stock/CreateUpdateSpareParts";
import ListSpareParts from "./page/admin/Stock/ListSpareParts";
import ListStock from "./page/admin/Stock/ListStock";
import ListStockHistory from "./page/admin/Stock/ListStockHistory";

const Routes = (props) => (
  <Router {...props}>

    {/* PUBLIC */}
    <Route path="/" component={Loading} />
    <Route path="/login" component={Login} />

    {/* ADMIN */}
    <Route path="/dashboard" component={Dashboard} />
    <Route path="/console" component={Console} />
    <Route path="/log" component={Log} />
    <Route path="/master" component={Master} />

    {/* MANAGE REPAIR  */}
    <Route path="/manage-repair/calendar-repair" component={CalendarRepair} />
    <Route path="/manage-repair/repair/create" component={CreateUpdateRepair} />
    <Route path="/manage-repair/repair/update" component={CreateUpdateRepair} />
    <Route path="/manage-repair/list-repair" component={ListRepair} />

    {/* MASTER */}
    <Route path="/master/customer/create" component={CreateUpdateCustomer} />
    <Route path="/master/customer/update" component={CreateUpdateCustomer} />
    <Route path="/master/role/create" component={CreateUpdateRole} />
    <Route path="/master/role/update" component={CreateUpdateRole} />
    <Route path="/master/spare-parts-repair/create" component={CreateUpdateSparePartsRepair} />
    <Route path="/master/spare-parts-repair/update" component={CreateUpdateSparePartsRepair} />
    <Route path="/master/list-admin" component={ListAdmin} />
    <Route path="/master/list-car" component={ListCar} />
    <Route path="/master/list-category" component={ListCategory} />
    <Route path="/master/list-warehouse" component={ListWarehouse} />
    <Route path="/master/list-customer" component={ListCustomer} />
    <Route path="/master/list-insurance" component={ListInsurance} />
    <Route path="/master/list-role" component={ListRole} />
    <Route path="/master/list-spare-parts-repair" component={ListSparePartsRepair} />
    <Route path="/master/list-suppliers" component={ListSuppliers} />
    <Route path="/master/barcode" component={BarcodeConfig} />
    <Route path="/master/print-barcode" component={ListBarcodeForSpare} />

    {/* ORDER */}
    <Route path="/order/approve-order/detail" component={ApproveOrderDetail} />
    <Route path="/order/order/create" component={CreateUpdateOrder} />
    <Route path="/order/order/update" component={CreateUpdateOrder} />
    <Route path="/order/receipt/create" component={CreateUpdateReceipt} />
    <Route path="/order/receipt/update" component={CreateUpdateReceipt} />
    <Route path="/order/list-approve-order" component={ListApproveOrder} />
    <Route path="/order/list-order" component={ListOrder} />
    <Route path="/order/list-receipt" component={ListReceipt} />

    {/* REPORT */}
    <Route path="/report/billing" component={ReportBilling} />
    <Route path="/report/receipt" component={ReportReceipt} />
    <Route path="/report/repair" component={ReportRepair} />
    <Route path="/report/spare-parts" component={ReportSpareParts} />
    <Route path="/report/spare-parts-minimal" component={ReportSparePartsMinimal} />
    <Route path="/report/inssure-part" component={ReportInsuurePart} />
    <Route path="/report/recieve-spare-parts" component={ReportRecievedSpareParts} />
    <Route path="/report/stock" component={ReportStock} />

    {/* SALE */}
    <Route path="/sale/billing/create" component={CreateUpdateBilling} />
    <Route path="/sale/billing/update" component={CreateUpdateBilling} />
    <Route path="/sale/invoice/create" component={CreateUpdateInvoice} />
    <Route path="/sale/invoice/update" component={CreateUpdateInvoice} />
    <Route path="/sale/quotation/create" component={CreateUpdateQuotation} />
    <Route path="/sale/quotation/update" component={CreateUpdateQuotation} />
    <Route path="/sale/sale/create" component={CreateUpdateSale} />
    <Route path="/sale/sale/update" component={CreateUpdateSale} />
    <Route path="/sale/list-billing" component={ListBilling} />
    <Route path="/sale/list-invoice" component={ListInvoice} />
    <Route path="/sale/list-quotation" component={ListQuotation} />
    <Route path="/sale/list-sale" component={ListSale} />

    {/* STOCK */}
    <Route path="/stock/spare-parts/create" component={CreateUpdateSpareParts} />
    <Route path="/stock/spare-parts/update" component={CreateUpdateSpareParts} />
    <Route path="/stock/list-spare-parts" component={ListSpareParts} />
    <Route path="/stock/list-stock" component={ListStock} />
    <Route path="/stock/list-stock-history" component={ListStockHistory} />


    <Route path="/*" component={NotFound} />
  </Router>
)

export default Routes
